import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <section className="space-y-3">
      <h1 className="font-heading text-2xl">الصفحة مش موجودة</h1>
      <Link to="/" className="underline underline-offset-4">
        رجوع للرئيسية
      </Link>
    </section>
  );
}
